import {
    CONFIRMATION_ON_SALES,
    PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON,
    PRIMARY_BUSINESS_ADDRESS,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/TDIApplication';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatTDIApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    licence = {
        id: 'telecommunication-dealers-individual',
        formID: 'telecommunication-dealers-individual',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${CONFIRMATION_ON_SALES}-do-you-intend-to-sell-m2m-equipment`]:
                licenceDetails?.confirmationOnSalesOfM2MProhibitedTelecommunicationEquipmentOrSm?.doYouIntendToSellM2MEquipment ?? '-',
            [`${CONFIRMATION_ON_SALES}-do-you-intend-to-sell-prohibited-telecommunication-equipment`]:
                licenceDetails?.confirmationOnSalesOfM2MProhibitedTelecommunicationEquipmentOrSm
                    ?.doYouIntendToSellProhibitedTelecommunicationEquipment ?? '-',
            [`${CONFIRMATION_ON_SALES}-do-you-intend-to-sell-sms-sim-box`]:
                licenceDetails?.confirmationOnSalesOfM2MProhibitedTelecommunicationEquipmentOrSm?.doYouIntendToSellSmsSimBox ?? '-',

            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-name`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.name ?? '-',
            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-designation`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.designation ?? '-',
            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-email`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.email ?? '-',
            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-office-tel-number`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.officeTelNumber ?? '-',
            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-mobile-number`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.mobileNumber ?? '-',

            [`${PRIMARY_BUSINESS_ADDRESS}-building-name`]: licenceDetails?.BusinessLocation[0]?.address?.buildingName ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-postal-code`]: licenceDetails?.BusinessLocation[0]?.address?.postalCode ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-street-name`]: licenceDetails?.BusinessLocation[0]?.address?.streetName ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-block-house-no`]: licenceDetails?.BusinessLocation[0]?.address?.blockNo ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-floor-level-optional`]: licenceDetails?.BusinessLocation[0]?.address?.floor ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-unit-optional`]: licenceDetails?.BusinessLocation[0]?.address?.unit ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-telecommunication-dealers-individual',
            formID: 'amend-telecommunication-dealers-individual',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${CONFIRMATION_ON_SALES}-amend-table`]: [...mapped],
                [`${CONFIRMATION_ON_SALES}-do-you-intend-to-sell-m2m-equipment`]:
                    licenceDetails?.confirmationOnSalesOfM2MProhibitedTelecommunicationEquipmentOrSm?.doYouIntendToSellM2MEquipment ?? '-',
                [`${CONFIRMATION_ON_SALES}-do-you-intend-to-sell-prohibited-telecommunication-equipment`]:
                    licenceDetails?.confirmationOnSalesOfM2MProhibitedTelecommunicationEquipmentOrSm
                        ?.doYouIntendToSellProhibitedTelecommunicationEquipment ?? '-',
                [`${CONFIRMATION_ON_SALES}-do-you-intend-to-sell-sms-sim-box`]:
                    licenceDetails?.confirmationOnSalesOfM2MProhibitedTelecommunicationEquipmentOrSm?.doYouIntendToSellSmsSimBox ?? '-',

                [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-name`]:
                    licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.name ?? '-',
                [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-designation`]:
                    licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.designation ?? '-',
                [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-email`]:
                    licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.email ?? '-',
                [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-office-tel-number`]:
                    licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.officeTelNumber ?? '-',
                [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-mobile-number`]:
                    licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.mobileNumber ?? '-',

                [`${PRIMARY_BUSINESS_ADDRESS}-building-name`]: licenceDetails?.BusinessLocation[0]?.address?.buildingName ?? '-',
                [`${PRIMARY_BUSINESS_ADDRESS}-postal-code`]: licenceDetails?.BusinessLocation[0]?.address?.postalCode ?? '-',
                [`${PRIMARY_BUSINESS_ADDRESS}-street-name`]: licenceDetails?.BusinessLocation[0]?.address?.streetName ?? '-',
                [`${PRIMARY_BUSINESS_ADDRESS}-block-house-no`]: licenceDetails?.BusinessLocation[0]?.address?.blockNo ?? '-',
                [`${PRIMARY_BUSINESS_ADDRESS}-floor-level-optional`]: licenceDetails?.BusinessLocation[0]?.address?.floor ?? '-',
                [`${PRIMARY_BUSINESS_ADDRESS}-unit-optional`]: licenceDetails?.BusinessLocation[0]?.address?.unit ?? '-',

                [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
            }
        };
    }

    return licence;
};

const tdiPayloadApplication = {
    formatTDIApplication
};

export default tdiPayloadApplication;
